<!--For testing functionality only, remove when third party payment is complete-->
<template>
  <page-wrapper>
    <v-row>
      <v-col cols="6">
        <v-card height="100%">
          <v-card-title style="text-align:center; " class="pb-0 mb-0">
            <div class="d-flex px-6" style="gap:48px; align-items: center">
              <div class="flex-grow-0">
                <img :src="require(`@/assets/paymentClient/simulated/logo.png`)" alt=""/>
              </div>
              <v-divider vertical/>
              <div class="flex-grow-1">
                {{ 'Token Generation' }}
              </div>
            </div>
          </v-card-title>
          <v-divider class="my-2"/>
          <v-card-text class="mt-0">
            <dl class="d-grid grid-4060">
              <dt>
                {{ 'Request ID' }}
              </dt>
              <dd>
                {{ requestID }}
              </dd>
              <dt>
                {{ 'Token Value' }}
              </dt>
              <dd>
                {{ tokenValue }}
              </dd>
              <dt>
                {{ 'Payment Description' }}
              </dt>
              <dd>
                {{ paymentDescription }}
              </dd>
              <dt>
                {{ 'Card Type Name' }}
              </dt>
              <dd>
                {{ cardTypeName }}
              </dd>
              <dt>
                {{ 'Card Number Last 4' }}
              </dt>
              <dd>
                {{ cardNumberLast4 }}
              </dd>
              <dt>
                {{ 'Card Expiration Year' }}
              </dt>
              <dd>
                {{ cardExpirationYear }}
              </dd>
              <dt>
                {{ 'Card Expiration Month' }}
              </dt>
              <dd>
                {{ cardExpirationMonth }}
              </dd>
            </dl>
          </v-card-text>
          <v-card-actions>
            <div class="text-right" style="flex: 1 1 auto">
              <c-btn block type="primary" @click="onAccept">
                {{ 'Accept' }}
              </c-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </page-wrapper>
</template>

<script>
import PageMixin from '@/mixins/page';
import PageWrapper from '@components/support/PageWrapper';

export default {
  components: { PageWrapper },
  mixins: [ PageMixin ],
  props: {
    requestID: {
      type: String,
      required: true
    },
    tokenValue: {
      type: String,
      required: true
    },
    paymentDescription: {
      type: String,
      required: true
    },
    cardTypeName: {
      type: String,
      required: true
    },
    cardNumberLast4: {
      type: String,
      required: true
    },
    cardExpirationYear: {
      type: String,
      required: true
    },
    cardExpirationMonth: {
      type: String,
      required: true
    }
  },
  methods: {
    onAccept () {
      this.$cove.blockNow();

      let redirectLocation = this.$cove.getAPI({ name: 'api.paymentclient.confirmation',
        query: {
          requestID: this.requestID,
          tokenValue: this.tokenValue,
          paymentDescription: this.paymentDescription,
          cardTypeName: this.cardTypeName,
          cardNumberLast4: this.cardNumberLast4,
          cardExpirationYear: this.cardExpirationYear,
          cardExpirationMonth: this.cardExpirationMonth
        }
      });
      window.location.href = redirectLocation;
    }
  }
};
</script>